import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
   providedIn: "root",
})
export class SharedLoaderService {
   private showLoader = new Subject<void>();
   showLoader$ = this.showLoader.asObservable();

   private hideLoader = new Subject<void>();
   hideLoader$ = this.hideLoader.asObservable();

   show() {
      this.showLoader.next();
   }

   hide() {
      this.hideLoader.next();
   }
}
